/**
 * @file Notebook移动版预览组件
 * @author FranckChen(chenfan02@baidu.com)
 */

import React from 'react';
import { Spin } from 'antd';

// components
import MarkdownCell from '../common/markdownCell';
import CodeCell from '../common/codeCell';
import ErrorInfo from '../common/ErrorInfo';

// util
import {isCodeCell, isMarkdownCell} from '../types/cellType';

// types
import {IIpynb} from '../types/notebook';

import '../style/mobile.less';

export interface INotebookPreviewProps {
    ipynb: IIpynb;
    loading?: boolean;
}

const NotebookMobilePreviewMain: React.FC<INotebookPreviewProps> = (props) => {
    const cells = props.ipynb.cells || [];
    const loading = props.loading || false;

    if (!cells && !loading) {
        return <ErrorInfo />;
    }

    return (
        <Spin spinning={loading}>
            <div className="ai-np">
                {
                    cells.map((cellData, index) => {
                        // TODO 添加更合理的key值
                        if (isMarkdownCell(cellData)) {
                            return <MarkdownCell {...cellData} key={index} />;
                        }
                        else if (isCodeCell(cellData)) {
                            return <CodeCell {...cellData} key={index} />;
                        }
                        return null;
                    })
                }
            </div>
        </Spin>
    );
};

export default NotebookMobilePreviewMain;
